@if (appVersionService.isUpdating()) {
  <app-update-overlay />
}

<app-sidenav></app-sidenav>

<!-- Portal outlet for footer content - outside sidenav for proper z-index -->
<div class="global-footer">
  <ng-template cdkPortalOutlet></ng-template>
</div>